//angular imports
import { Signal } from "@angular/core";

//local imports
import { AbstractProgramNavModel, SelectProgramMessage } from "@app/catalog-common";
import { ProgramModel } from "@app/catalog";
import { IListItem, ListItem, Messenger } from "@app/shared";


export class ProgramsNavModel 
  extends AbstractProgramNavModel<ProgramModel> {

 constructor(
    messenger: Messenger,
    items: Signal<ProgramModel[]>
  ) {
    super(messenger, items);
  }

  public select(item: IListItem): void {
    const navItem = item as ListItem<ProgramModel>;
    this.messenger.send(new SelectProgramMessage(navItem.value));
  }

}